import { render, staticRenderFns } from "./merchantlist.vue?vue&type=template&id=68a907f2&scoped=true"
import script from "./merchantlist.vue?vue&type=script&lang=js"
export * from "./merchantlist.vue?vue&type=script&lang=js"
import style0 from "./merchantlist.vue?vue&type=style&index=0&id=68a907f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a907f2",
  null
  
)

export default component.exports